module.exports = __webpack_public_path__ + "media/packs/site/assets/images/watermark1-96e1d57259fd94c862521dc3ca55a44b.svg";